// @flow
import React from 'react';
import { useTranslation } from 'react-i18next';

import SingleStatus from './ProviderSingleStatus';

import { Status as StatusType } from '../../types/status';


type Props = {
  status: StatusType
}

const ProviderStatus = ({ status }: Props) => {
  const { t } = useTranslation('waitingStates');
  const allWaitingStates = t('all', { returnObjects: true });
  const waitingStatesLoaded = Array.isArray(allWaitingStates);

  if (waitingStatesLoaded) {
    const statusExists = allWaitingStates.map((waitingState) =>
      status && status.status_history && status.status_history.find((item) => item.status_type.id === waitingState.id));

    const allStatuses = statusExists.map((item, i) => {
      const statusMessage = allWaitingStates.find((state) => item && item.status_type.id === state.id);
      return (
        <li className='providers__status status__list-item'>
          {item &&
            <SingleStatus
              key={i}
              done
              recordsAvailable={statusMessage.id === 9}
              date={item.created_at}
              followup={statusMessage.followUp}
              status={statusMessage.messageShort}
            />}
          {!item && !allWaitingStates[i].optional &&
            <SingleStatus
              key={i}
              status={allWaitingStates[i].messagePending}
            />}
        </li>
      );
    });
    return (
      <ul className='status__list'>
        {allStatuses}
      </ul>
    );
  }
  return null;
};

export default ProviderStatus;



// WEBPACK FOOTER //
// ./src/components/shared/ProviderStatus.js